/*
  LANDING 199 — comportamento della scheda lunga.

  Un file solo per tutta la pagina, perche' i pezzi si parlano:

  - CONTO ALLA ROVESCIA della barra in alto;
  - PACCHETTI: "una borsa" / "due borse a 199". Il pacchetto scelto decide
    quante caselle vanno riempite e cosa succede al checkout;
  - SCELTA DELLE BORSE: le caselle aprono un cassetto con tutto il catalogo;
    da li' si guarda la scheda di una borsa (foto, prezzo, descrizione presi
    da /products/<handle>.js) e la si mette nella coppia;
  - CARRELLO: aggiunge le borse scelte e, quando il pacchetto e' la coppia,
    passa dal permalink dello sconto cosi' il prezzo fisso si applica solo
    partendo da questa pagina;
  - SINCRONIA: l'offerta compare due volte nella pagina (in alto e in fondo,
    come nel riferimento). Le due copie mostrano sempre la stessa cosa
    perche' lo stato e' uno solo, qui dentro.

  Se la Function degli sconti non fosse attiva la pagina funziona lo stesso:
  si arriva al checkout a prezzo pieno e l'errore si vede subito, invece di
  restare nascosto.
*/
(function () {
  'use strict';

  function euro(c) { return '€' + (c / 100).toFixed(2).replace('.', ','); }

  /* ------------------------------------------------------------------ */
  /* conto alla rovescia                                                 */
  /* ------------------------------------------------------------------ */
  function conti() {
    [].forEach.call(document.querySelectorAll('[data-pd-conto]'), function (box) {
      if (box.dataset.pdAcceso === '1') return;
      box.dataset.pdAcceso = '1';

      var ore = Number(box.getAttribute('data-pd-ore')) || 2;
      var chiave = 'vx_pd_conto';
      var fine;
      /* La finestra riparte da capo per ogni visitatore ma non a ogni
         ricarica: altrimenti il conto ricomincia e si capisce che e' finto. */
      try {
        fine = Number(sessionStorage.getItem(chiave));
        if (!fine || fine < Date.now()) {
          fine = Date.now() + ore * 3600 * 1000;
          sessionStorage.setItem(chiave, String(fine));
        }
      } catch (e) { fine = Date.now() + ore * 3600 * 1000; }

      var celle = {
        h: box.querySelector('[data-pd-h]'),
        m: box.querySelector('[data-pd-m]'),
        s: box.querySelector('[data-pd-s]')
      };
      function due(n) { return (n < 10 ? '0' : '') + n; }
      function batti() {
        var resta = Math.max(0, fine - Date.now());
        var t = Math.floor(resta / 1000);
        if (celle.h) celle.h.textContent = due(Math.floor(t / 3600));
        if (celle.m) celle.m.textContent = due(Math.floor(t % 3600 / 60));
        if (celle.s) celle.s.textContent = due(t % 60);
      }
      batti();
      setInterval(batti, 1000);
    });
  }

  /* ------------------------------------------------------------------ */
  /* stato condiviso fra le due copie dell'offerta                       */
  /* ------------------------------------------------------------------ */
  var stato = { pacchetto: null, scelte: [], catalogo: [], copie: [] };

  function quante() { return stato.pacchetto ? stato.pacchetto.quantita : 0; }
  function pieni() { return stato.scelte.filter(Boolean).length; }

  /* Quanto costerebbero, di listino, le borse messe nelle caselle.
     Serve ai pacchetti senza prezzo fisso ("una borsa": dipende da quale) e
     al prezzo barrato della coppia, che cambia con le borse scelte. */
  function sommaScelte() {
    return stato.scelte.reduce(function (t, b) { return t + (b ? b.prezzo : 0); }, 0);
  }

  function scegliPacchetto(p) {
    stato.pacchetto = p;
    stato.scelte = stato.scelte.slice(0, p.quantita);
    while (stato.scelte.length < p.quantita) stato.scelte.push(null);
    disegnaTutto();
  }

  function mettiBorsa(b) {
    var dove = stato.scelte.findIndex(function (x) { return x && x.id === b.id; });
    if (dove !== -1) { stato.scelte[dove] = null; return disegnaTutto(); }
    var libera = stato.scelte.indexOf(null);
    if (libera === -1) { stato.scelte[stato.scelte.length - 1] = b; }
    else { stato.scelte[libera] = b; }
    disegnaTutto();
    if (stato.scelte.indexOf(null) === -1) chiudiCassetto();
  }

  function disegnaTutto() {
    stato.copie.forEach(function (c) { c.disegna(); });
    disegnaCassetto();
  }

  /* ------------------------------------------------------------------ */
  /* una copia dell'offerta                                              */
  /* ------------------------------------------------------------------ */
  function preparaOfferta(radice) {
    if (radice.dataset.pdPronta === '1') return;
    radice.dataset.pdPronta = '1';

    var pacchetti = [].map.call(radice.querySelectorAll('[data-pd-pacchetto]'), function (el) {
      return {
        el: el,
        id: el.getAttribute('data-pd-pacchetto'),
        quantita: Number(el.getAttribute('data-pd-qta')) || 1,
        prezzo: Number(el.getAttribute('data-pd-prezzo')) || 0,
        pieno: Number(el.getAttribute('data-pd-pieno')) || 0,
        codice: (el.getAttribute('data-pd-codice') || '').trim()
      };
    });
    if (!pacchetti.length) return;

    var caselle = radice.querySelector('[data-pd-caselle]');
    var compra  = radice.querySelector('[data-pd-compra]');
    var avviso  = radice.querySelector('[data-pd-avviso]');
    var prezzoOra   = radice.querySelector('[data-pd-prezzoora]');
    var prezzoPieno = radice.querySelector('[data-pd-prezzopieno]');
    var risparmio   = radice.querySelector('[data-pd-risparmio]');
    var etichettaCompra = compra ? compra.getAttribute('data-pd-testo') || 'Aggiungi al carrello' : '';

    pacchetti.forEach(function (p) {
      p.el.addEventListener('click', function () { scegliPacchetto(cercaPacchetto(p.id)); });
    });

    function cercaPacchetto(id) {
      /* Si cerca fra i pacchetti di QUESTA copia, ma lo stato e' comune:
         le due copie hanno gli stessi identificativi. */
      return pacchetti.filter(function (x) { return x.id === id; })[0];
    }

    function disegnaCaselle() {
      if (!caselle) return;
      caselle.innerHTML = '';
      if (quante() < 1) return;
      for (var i = 0; i < quante(); i++) {
        (function (i) {
          var b = stato.scelte[i];
          var giro = document.createElement('div');
          giro.className = 'pd-casella__ratio';
          var casella = document.createElement('button');
          casella.type = 'button';
          casella.className = 'pd-casella' + (b ? ' e-piena' : '');
          casella.innerHTML = b
            ? '<img src="' + b.img + '" alt=""><span class="pd-casella__nome">' + b.titolo + '</span>'
            : '<span class="pd-casella__dentro"><span class="pd-casella__piu">+</span>' +
              '<span class="pd-casella__eti">Borsa ' + (i + 1) + '</span></span>';
          casella.addEventListener('click', function () { apriCassetto(i); });
          giro.appendChild(casella);
          caselle.appendChild(giro);
        })(i);
      }
    }

    function disegna() {
      var scelto = stato.pacchetto;
      pacchetti.forEach(function (p) {
        var attivo = scelto && p.id === scelto.id;
        p.el.classList.toggle('e-scelto', !!attivo);
        p.el.setAttribute('aria-pressed', attivo ? 'true' : 'false');
      });
      if (!scelto) return;

      /* Prezzo fisso se il pacchetto ne ha uno (la coppia a 199), altrimenti
         quello delle borse scelte. Il barrato e' sempre il listino vero. */
      var somma = sommaScelte();
      var ora = scelto.prezzo || somma;
      /* Se la coppia scelta costa gia' meno del prezzo fisso, il prezzo
         fisso non si applica (lo sconto sarebbe negativo) e al checkout si
         paga il listino: qui si scrive quello, non 199. Succede con le
         borse piu' economiche. */
      if (somma && scelto.prezzo && somma < scelto.prezzo) ora = somma;
      var pieno = scelto.pieno || somma;

      if (prezzoOra) prezzoOra.textContent = ora ? euro(ora) : '—';
      if (prezzoPieno) prezzoPieno.textContent = pieno > ora ? euro(pieno) : '';
      if (risparmio) {
        risparmio.textContent = pieno > ora ? 'Risparmi ' + euro(pieno - ora) : '';
        risparmio.hidden = !(pieno > ora);
      }

      disegnaCaselle();

      if (compra) {
        var mancano = quante() - pieni();
        var testo = mancano > 0
          ? (mancano === quante() ? 'Scegli ' + (quante() === 1 ? 'la borsa' : 'le borse') : 'Manca ' + mancano + ' borsa')
          : etichettaCompra;
        compra.innerHTML = '<span>' + testo + '</span>' +
          (mancano > 0 ? '' : '<span class="pd-compra__prezzo">' +
            (pieno > ora ? '<s>' + euro(pieno) + '</s> ' : '') + euro(ora) + '</span>');
        compra.classList.toggle('e-pronto', mancano === 0);
      }
      if (avviso) avviso.hidden = true;
    }

    function compraOra() {
      if (!stato.pacchetto) return;
      var mancano = quante() - pieni();
      if (mancano > 0) { apriCassetto(stato.scelte.indexOf(null)); return; }
      if (avviso) avviso.hidden = true;
      if (compra) { compra.setAttribute('disabled', 'true'); compra.innerHTML = '<span>Un attimo…</span>'; }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({items: stato.scelte.map(function (b) { return {id: Number(b.id), quantity: 1}; })})
      }).then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      }).then(function () {
        var c = stato.pacchetto.codice;
        window.location.href = c ? '/discount/' + encodeURIComponent(c) + '?redirect=/checkout' : '/checkout';
      }).catch(function (err) {
        if (compra) compra.removeAttribute('disabled');
        disegna();
        if (avviso) {
          avviso.textContent = 'Qualcosa non ha funzionato. Riprova o scrivici su WhatsApp.';
          avviso.hidden = false;
        }
        if (window.console) console.warn('[vx-pd] aggiunta fallita:', err);
      });
    }

    if (compra) compra.addEventListener('click', compraOra);

    stato.copie.push({disegna: disegna});

    /* Alla prima copia si sceglie il pacchetto consigliato, o il primo. */
    if (!stato.pacchetto) {
      var consigliato = pacchetti.filter(function (p) { return p.el.hasAttribute('data-pd-preferito'); })[0];
      scegliPacchetto(consigliato || pacchetti[0]);
    } else {
      disegna();
    }
  }

  /* ------------------------------------------------------------------ */
  /* il cassetto del catalogo + la scheda della singola borsa            */
  /* ------------------------------------------------------------------ */
  var cassetto, griglia, filtri, schedaBox, schedaCorpo, schedaAzione;
  var schede = {}, apertaOra = null, scrollBloccato = '';
  /* Due filtri indipendenti che lavorano insieme: "camoscio" + "verde
     bosco" mostra solo le borse che sono tutte e due le cose. */
  var filtro = {materiale: '', colore: ''};

  var COLORI = {
    'nera': '#1B1116', 'nero': '#1B1116', 'cuoio': '#A9713C', 'marrone': '#6B4A33',
    'testa di moro': '#4A3227', 'beige': '#D8C6AE', 'panna': '#EFE7DA', 'tortora': '#B3A493',
    'bordeaux': '#6B1F2B', 'borgogna': '#6B1F2B', 'rosso': '#A3242B', 'fucsia': '#C2325F',
    'rosa': '#E8B4C4', 'viola': '#5B3A73', 'verde bosco': '#27402F', 'verde': '#2F5B3F',
    'petrolio': '#17535E', 'blu': '#26354F', 'celeste': '#9FC4D8', 'grigio': '#8C8C8C',
    'senape': '#C9962F', 'giallo': '#E0B93C', 'arancione': '#CF7A3A', 'bianca': '#F3F1EC'
  };
  function pallino(nome) {
    var n = (nome || '').toLowerCase();
    if (COLORI[n]) return COLORI[n];
    if (n.indexOf('leopard') !== -1) return 'repeating-linear-gradient(48deg,#C9962F 0 4px,#3A2A1C 4px 7px)';
    return '#CFC8BF';
  }

  function apriCassetto() {
    if (!cassetto) return;
    scrollBloccato = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    cassetto.hidden = false;
    disegnaCassetto();
  }
  function chiudiCassetto() {
    if (!cassetto) return;
    cassetto.hidden = true;
    document.body.style.overflow = scrollBloccato;
  }

  function elencoDi(campo) {
    var visti = [];
    stato.catalogo.forEach(function (b) {
      var v = (b[campo] || '').trim();
      if (v && visti.indexOf(v) === -1) visti.push(v);
    });
    return visti.sort();
  }

  function disegnaFiltri() {
    if (!filtri) return;
    filtri.innerHTML = '';

    function fila(classe, etichetta) {
      var f = document.createElement('div');
      f.className = 'pd-filtri ' + classe;
      var e = document.createElement('span');
      e.className = 'pd-filtri__eti';
      e.textContent = etichetta;
      f.appendChild(e);
      filtri.appendChild(f);
      return f;
    }

    function tutti(f, campo, testo) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'pd-chip pd-chip--tutte';
      b.textContent = testo;
      b.setAttribute('data-pd-filtro', campo);
      b.setAttribute('data-pd-valore', '');
      b.addEventListener('click', function () { filtro[campo] = ''; disegnaCassetto(); });
      f.appendChild(b);
    }

    var materiali = elencoDi('materiale');
    if (materiali.length > 1) {
      var fm = fila('pd-filtri--materiale', 'Materiale');
      tutti(fm, 'materiale', 'Tutti');
      materiali.forEach(function (m) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'pd-chip pd-chip--parola';
        /* Le etichette arrivano dai tag: "calf-hair" si legge male. */
        b.textContent = m.replace(/-/g, ' ');
        b.setAttribute('data-pd-filtro', 'materiale');
        b.setAttribute('data-pd-valore', m);
        b.addEventListener('click', function () { filtro.materiale = m; disegnaCassetto(); });
        fm.appendChild(b);
      });
    }

    var colori = elencoDi('colore');
    /* Il colore su cui la pagina e' costruita va per primo anche fra i
       pallini: chi arriva da un annuncio tutto in borgogna lo cerca li',
       non in mezzo all'ordine alfabetico fra "blu navy" e "cuoio". Lo dice
       la sezione con data-pd-colore-primo; senza, l'ordine resta quello di
       sempre. */
    var radiceScheda = document.querySelector('[data-pd-colore-primo]');
    var primoColore = radiceScheda ? (radiceScheda.getAttribute('data-pd-colore-primo') || '').trim() : '';
    if (primoColore && colori.indexOf(primoColore) > 0) {
      colori.splice(colori.indexOf(primoColore), 1);
      colori.unshift(primoColore);
    }
    if (colori.length > 1) {
      var fc = fila('pd-filtri--colore', 'Colore');
      tutti(fc, 'colore', 'Tutti');
      colori.forEach(function (c) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'pd-chip pd-chip--colore';
        b.title = c.charAt(0).toUpperCase() + c.slice(1);
        b.setAttribute('aria-label', c);
        b.setAttribute('data-pd-filtro', 'colore');
        b.setAttribute('data-pd-valore', c);
        b.innerHTML = '<span class="pd-pallino" style="background:' + pallino(c) + '"></span>';
        b.addEventListener('click', function () { filtro.colore = c; disegnaCassetto(); });
        fc.appendChild(b);
      });
    }
  }

  function segnaFiltri() {
    if (!filtri) return;
    [].forEach.call(filtri.querySelectorAll('[data-pd-filtro]'), function (b) {
      var campo = b.getAttribute('data-pd-filtro');
      var val = b.getAttribute('data-pd-valore') || '';
      b.setAttribute('aria-pressed', filtro[campo] === val ? 'true' : 'false');
    });
  }

  function disegnaCassetto() {
    if (!griglia) return;
    var presa = function (b) { return stato.scelte.some(function (x) { return x && x.id === b.id; }); };
    var lista = stato.catalogo.filter(function (b) {
      if (filtro.materiale && (b.materiale || '') !== filtro.materiale) return false;
      if (filtro.colore && (b.colore || '') !== filtro.colore) return false;
      return true;
    });
    griglia.innerHTML = '';
    /* 13/10/2026 — al posto del «+» tondo sulla foto, un pulsante con una
       parola sotto la borsa («Aggiungi»), dove la sezione lo chiede con
       data-pd-aggiungi. Toccato di nuovo la toglie, come il «+». */
    var parola = (cassetto && cassetto.getAttribute('data-pd-aggiungi')) || '';
    parola = parola.replace(/[<>&"]/g, '');
    lista.forEach(function (b) {
      var card = document.createElement('article');
      card.className = 'pd-card' + (presa(b) ? ' e-presa' : '') + (parola ? ' e-parola' : '');
      card.innerHTML =
        '<span class="pd-card__ratio">' +
        '<button type="button" class="pd-card__foto e-attesa" aria-label="Guarda ' + (b.titolo || '').replace(/"/g, '') + '">' +
          '<img data-pd-src="' + (b.img || '') + '" alt="' + (b.titolo || '').replace(/"/g, '') + '"' +
            ' data-pd-titolo="' + (b.titolo || '').replace(/"/g, '') + '"' +
            ' data-pd-colore="' + pallino(b.colore) + '" decoding="async">' +
          '<span class="pd-card__guarda">Guarda</span>' +
        '</button></span>' +
        (parola ? '' : '<button type="button" class="pd-card__piu">' + (presa(b) ? '&minus;' : '+') + '</button>') +
        '<p class="pd-card__riga"><span>' + b.titolo + '</span><span class="pd-card__prezzo">' + euro(b.prezzo) + '</span></p>' +
        (parola ? '<button type="button" class="pd-card__piu pd-card__piu--parola">' + (presa(b) ? '&#10003; Aggiunta' : parola) + '</button>' : '');
      var foto = card.querySelector('.pd-card__foto');
      foto.addEventListener('click', function () { apriScheda(b); });
      card.querySelector('.pd-card__piu').addEventListener('click', function (e) { e.stopPropagation(); mettiBorsa(b); });
      griglia.appendChild(card);
    });
    [].forEach.call(document.querySelectorAll('[data-pd-conta]'), function (x) {
      x.textContent = pieni() + ' di ' + quante();
    });
    if (!lista.length) griglia.innerHTML = '<p class="pd-vuoto">Nessuna borsa con questa combinazione. Prova a togliere un filtro.</p>';
    segnaFiltri();
    accendiFoto();
  }

  /* ---- le foto del cassetto, una manciata per volta ----
     Chiedere cinquanta foto tutte insieme non funziona: il browser ne
     porta a casa qualcuna e abbandona le altre, e restano riquadri
     bianchi (succedeva davvero, su Brave e non solo). Qui la foto si
     chiede solo quando la sua carta sta per entrare nello schermo del
     cassetto, e se una richiesta fallisce si riprova una volta sola. */
  var occhioFoto = null;
  function chiedi(imm) {
    if (!imm || imm.dataset.pdChiesta === '1') return;
    imm.dataset.pdChiesta = '1';
    var riquadro = imm.parentElement;
    imm.addEventListener('load', function () { riquadro.classList.remove('e-attesa'); });
    imm.addEventListener('error', function () {
      if (imm.dataset.pdRiprova !== '1') {
        imm.dataset.pdRiprova = '1';
        setTimeout(function () { imm.src = imm.getAttribute('data-pd-src'); }, 600);
        return;
      }
      /* Due tentativi andati male: puo' succedere con un blocco
         pubblicitario aggressivo o una rete che fa i capricci. Invece di
         lasciare un riquadro bianco si mostra il colore della borsa e il
         suo nome: la si puo' comunque scegliere. */
      riquadro.classList.remove('e-attesa');
      riquadro.classList.add('e-senza-foto');
      if (riquadro.querySelector('.pd-card__ripiego')) return;
      var rip = document.createElement('span');
      rip.className = 'pd-card__ripiego';
      rip.innerHTML = '<span class="pd-card__tinta" style="background:' + (imm.getAttribute('data-pd-colore') || '#CFC8BF') + '"></span>' +
                      '<span>' + (imm.getAttribute('data-pd-titolo') || '') + '</span>';
      riquadro.appendChild(rip);
    });
    imm.src = imm.getAttribute('data-pd-src');
  }

  function accendiFoto() {
    if (!griglia) return;
    var immagini = [].slice.call(griglia.querySelectorAll('img[data-pd-src]'));
    /* Le prime dodici si chiedono sempre, osservatore o no: se per
       qualunque motivo l'osservatore non scatta, il cassetto si apre
       comunque pieno invece che bianco. */
    immagini.slice(0, 12).forEach(function (imm, i) { setTimeout(function () { chiedi(imm); }, i * 40); });
    if (!('IntersectionObserver' in window)) {
      /* Senza osservatore si va a scaglioni, per non partire con
         cinquanta richieste in una volta. */
      immagini.forEach(function (imm, i) { setTimeout(function () { chiedi(imm); }, i * 90); });
      return;
    }
    if (occhioFoto) occhioFoto.disconnect();
    occhioFoto = new IntersectionObserver(function (righe) {
      righe.forEach(function (r) {
        if (!r.isIntersecting) return;
        chiedi(r.target);
        occhioFoto.unobserve(r.target);
      });
    }, {root: griglia, rootMargin: '400px 0px'});
    immagini.forEach(function (imm) { occhioFoto.observe(imm); });
  }

  function disegnaScheda(b, extra) {
    if (!schedaCorpo) return;
    var foto = (extra && extra.images && extra.images.length ? extra.images : [b.img])
      .slice(0, 6).map(function (u, i) {
        var src = String(u).indexOf('//') === 0 ? 'https:' + u : u;
        src = src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=900';
        /* La prima si chiede subito, le altre in fila appena la
           precedente e' arrivata: sei richieste insieme dentro una
           finestra che si apre bastavano a far uscire un riquadro vuoto. */
        return i === 0
          ? '<img src="' + src + '" alt="" decoding="async" data-pd-prima>'
          : '<img data-pd-poi="' + src + '" alt="" decoding="async">';
      }).join('');
    var prezzo = extra ? extra.price : b.prezzo;
    var listino = extra ? (extra.compare_at_price || 0) : 0;
    schedaCorpo.innerHTML =
      '<div class="pd-sch__foto' + (foto ? '' : ' e-senza') + '">' + foto + '</div>' +
      '<div class="pd-sch__testo">' +
        '<h3 class="pd-sch__titolo">' + b.titolo + '</h3>' +
        '<p class="pd-sch__mat">' + [b.materiale, b.colore].filter(Boolean).join(' · ') + '</p>' +
        '<p class="pd-sch__prezzo">' + euro(prezzo) +
          (listino > prezzo ? '<s>' + euro(listino) + '</s>' : '') + '</p>' +
        '<div class="pd-sch__desc">' + ((extra && extra.description) || '') + '</div>' +
      '</div>';
    schedaCorpo.scrollTop = 0;
    (function inFila() {
      var resto = [].slice.call(schedaCorpo.querySelectorAll('img[data-pd-poi]'));
      var i = 0;
      function passo() {
        if (i >= resto.length) return;
        var imm = resto[i++];
        imm.addEventListener('load', passo);
        imm.addEventListener('error', passo);
        imm.src = imm.getAttribute('data-pd-poi');
      }
      var prima = schedaCorpo.querySelector('img[data-pd-prima]');
      if (!prima || (prima.complete && prima.naturalWidth > 0)) { passo(); }
      else { prima.addEventListener('load', passo); prima.addEventListener('error', passo); }
    })();
    if (schedaAzione) {
      var dentro = stato.scelte.some(function (x) { return x && x.id === b.id; });
      schedaAzione.textContent = dentro ? 'Toglila' : 'Scegli questa';
    }
  }

  function apriScheda(b) {
    if (!schedaBox) return;
    apertaOra = b;
    schedaBox.hidden = false;
    disegnaScheda(b, schede[b.handle] || null);
    if (!b.handle || schede[b.handle]) return;
    fetch('/products/' + b.handle + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        if (!d) return;
        schede[b.handle] = d;
        if (!schedaBox.hidden && apertaOra && apertaOra.id === b.id) disegnaScheda(b, d);
      }).catch(function () { /* resta la versione essenziale */ });
  }
  function chiudiScheda() { if (schedaBox) { schedaBox.hidden = true; apertaOra = null; } }

  function preparaCassetto(el) {
    if (el.dataset.pdPronto === '1') return;
    el.dataset.pdPronto = '1';
    cassetto = el;
    griglia = el.querySelector('[data-pd-griglia]');
    filtri = el.querySelector('[data-pd-filtri]');
    schedaBox = el.querySelector('[data-pd-scheda]');
    schedaCorpo = el.querySelector('[data-pd-schedacorpo]');
    schedaAzione = el.querySelector('[data-pd-schedaazione]');

    try { stato.catalogo = JSON.parse(el.querySelector('[data-pd-dati]').textContent).borse || []; }
    catch (e) { stato.catalogo = []; }

    [].forEach.call(el.querySelectorAll('[data-pd-chiudi]'), function (x) {
      x.addEventListener('click', chiudiCassetto);
    });
    [].forEach.call(el.querySelectorAll('[data-pd-schedachiudi]'), function (x) {
      x.addEventListener('click', chiudiScheda);
    });
    if (schedaAzione) {
      schedaAzione.addEventListener('click', function () {
        if (!apertaOra) return;
        var b = apertaOra;
        chiudiScheda();
        mettiBorsa(b);
      });
    }
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (schedaBox && !schedaBox.hidden) return chiudiScheda();
      if (cassetto && !cassetto.hidden) chiudiCassetto();
    });

    disegnaFiltri();
    disegnaCassetto();

    /* Niente precarico di tutto il catalogo: cinquanta richieste in
       sottofondo rubavano banda alle foto che servono davvero. */
  }

  /* ------------------------------------------------------------------ */
  /* galleria della scheda in alto                                       */
  /* ------------------------------------------------------------------ */
  function galleria() {
    [].forEach.call(document.querySelectorAll('[data-pd-galleria]'), function (g) {
      if (g.dataset.pdPronta === '1') return;
      g.dataset.pdPronta = '1';
      var grande = g.querySelector('[data-pd-grande]');
      [].forEach.call(g.querySelectorAll('[data-pd-mini]'), function (m) {
        m.addEventListener('click', function () {
          if (grande) grande.src = m.getAttribute('data-pd-mini');
          [].forEach.call(g.querySelectorAll('[data-pd-mini]'), function (x) { x.classList.remove('e-attiva'); });
          m.classList.add('e-attiva');
        });
      });
    });
  }

  /* ------------------------------------------------------------------ */
  /* la linea del tempo che si accende                                    */
  /* ------------------------------------------------------------------ */
  function lineaDelTempo() {
    [].forEach.call(document.querySelectorAll('[data-pd-linea]'), function (linea) {
      if (linea.dataset.pdPronta === '1') return;
      linea.dataset.pdPronta = '1';
      var tappe = [].slice.call(linea.querySelectorAll('[data-pd-tappa]'));
      if (!tappe.length) return;

      var fermi = false;
      try { fermi = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}
      if (fermi || !('IntersectionObserver' in window)) {
        tappe.forEach(function (t) { t.classList.add('e-accesa'); });
        linea.style.setProperty('--pd-riempimento', '100%');
        return;
      }

      /* Una tappa si accende quando arriva a meta' schermo e resta accesa:
         tornando indietro non si spegne, perche' vedere le spunte sparire
         darebbe l'impressione di aver perso qualcosa. */
      var occhio = new IntersectionObserver(function (righe) {
        righe.forEach(function (r) {
          if (!r.isIntersecting) return;
          r.target.classList.add('e-accesa');
          occhio.unobserve(r.target);
          var accese = linea.querySelectorAll('[data-pd-tappa].e-accesa').length;
          linea.style.setProperty('--pd-riempimento', Math.round(accese / tappe.length * 100) + '%');
        });
      }, {rootMargin: '0px 0px -45% 0px'});
      tappe.forEach(function (t) { occhio.observe(t); });
    });
  }

  /* Frecce dei nastri di carte. Scorrono di una carta per volta, misurata
     sul posto: cosi' funzionano anche quando la carta cambia larghezza. */
  function nastri() {
    [].forEach.call(document.querySelectorAll('[data-pd-nastro]'), function (pista) {
      if (pista.dataset.pdPronta === '1') return;
      pista.dataset.pdPronta = '1';
      var sezione = pista.closest('section');
      if (!sezione) return;
      [].forEach.call(sezione.querySelectorAll('[data-pd-scorri]'), function (b) {
        b.addEventListener('click', function () {
          var verso = Number(b.getAttribute('data-pd-scorri')) || 1;
          var carta = pista.querySelector(':scope > *');
          var passo = carta ? carta.getBoundingClientRect().width + 16 : pista.clientWidth * 0.8;
          pista.scrollBy({left: passo * verso, behavior: 'smooth'});
        });
      });
    });
  }

  /* ------------------------------------------------------------------ */
  /* i video delle clienti                                                */
  /* ------------------------------------------------------------------ */
  function clip() {
    [].forEach.call(document.querySelectorAll('[data-pd-ugc]'), function (pista) {
      if (pista.dataset.pdClipPronte === '1') return;
      pista.dataset.pdClipPronte = '1';

      var fermi = false;
      try { fermi = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}

      var carte = [].slice.call(pista.querySelectorAll('[data-pd-clip]'));
      var MASSIMO = 3;          /* mai piu' di tre video in moto insieme */
      var inMoto = [];

      function sorgente(card) {
        var v = card.querySelector('video');
        if (!v) return null;
        if (!v.getAttribute('src')) {
          var u = v.getAttribute('data-pd-video');
          if (!u) return null;
          v.setAttribute('src', u);
        }
        return v;
      }

      function parti(card) {
        var v = sorgente(card);
        if (!v || inMoto.indexOf(card) !== -1) return;
        if (inMoto.length >= MASSIMO) ferma(inMoto[0]);
        var p = v.play();
        if (p && p.catch) p.catch(function () { /* il browser puo' rifiutare: resta la copertina */ });
        card.classList.add('e-gira');
        inMoto.push(card);
      }

      function ferma(card) {
        var v = card.querySelector('video');
        if (v) { try { v.pause(); } catch (e) {} }
        card.classList.remove('e-gira');
        var i = inMoto.indexOf(card);
        if (i !== -1) inMoto.splice(i, 1);
      }

      /* Il suono si accende toccando, come su Instagram: uno solo per
         volta, altrimenti parlano tutte insieme. */
      carte.forEach(function (card) {
        card.addEventListener('click', function () {
          var v = sorgente(card);
          if (!v) return;
          if (fermi && v.paused) { parti(card); return; }
          if (v.muted) {
            carte.forEach(function (altra) {
              var av = altra.querySelector('video');
              if (av && altra !== card) { av.muted = true; var seg = altra.querySelector('[data-pd-audio]'); if (seg) seg.textContent = '🔇'; }
            });
            v.muted = false;
            parti(card);
          } else {
            v.muted = true;
          }
          var segno = card.querySelector('[data-pd-audio]');
          if (segno) segno.textContent = v.muted ? '🔇' : '🔊';
        });
      });

      if (fermi || !('IntersectionObserver' in window)) return;

      /* Il file si chiede solo quando la card e' quasi in scena, e parte
         solo quando si vede davvero. */
      var occhio = new IntersectionObserver(function (righe) {
        righe.forEach(function (r) {
          if (r.intersectionRatio >= 0.55) { parti(r.target); }
          else if (r.intersectionRatio < 0.25) { ferma(r.target); }
        });
      }, {root: pista, threshold: [0, 0.25, 0.55, 0.9]});
      carte.forEach(function (c) { occhio.observe(c); });

      /* Fuori dallo schermo della pagina si ferma tutto: non ha senso
         far girare video mentre si legge altro. */
      var occhioPagina = new IntersectionObserver(function (righe) {
        righe.forEach(function (r) {
          if (r.isIntersecting) return;
          inMoto.slice().forEach(ferma);
        });
      }, {rootMargin: '100px'});
      occhioPagina.observe(pista);
    });
  }

  /* ------------------------------------------------------------------ */
  /* diagnostica: si accende solo con ?vxdebug=1                          */
  /* ------------------------------------------------------------------ */
  function diagnostica() {
    if (location.search.indexOf('vxdebug=1') === -1) return;
    var box = document.createElement('div');
    box.setAttribute('style', 'position:fixed;left:8px;bottom:8px;z-index:2147483000;max-width:min(92vw,420px);' +
      'background:rgba(20,14,17,.93);color:#fff;font:11px/1.45 ui-monospace,Menlo,monospace;' +
      'padding:10px 12px;border-radius:8px;white-space:pre-wrap;');
    document.body.appendChild(box);

    var errori = [];
    window.addEventListener('error', function (e) {
      errori.push((e.message || 'errore') + ' @ ' + ((e.filename || '').split('/').pop() || '') + ':' + (e.lineno || ''));
    });

    function prova(regola) {
      try { return CSS.supports(regola) ? 'si' : 'NO'; } catch (e) { return '?'; }
    }

    function scrivi() {
      var carte = document.querySelectorAll('.pd-card');
      var img = [].slice.call(document.querySelectorAll('.pd-griglia img'));
      var prima = document.querySelector('.pd-card__foto');
      var r = prima ? prima.getBoundingClientRect() : null;
      box.textContent =
        'VX diagnostica\n' +
        'schermo ' + innerWidth + 'x' + innerHeight + ' dpr ' + (devicePixelRatio || 1) + '\n' +
        'catalogo ' + stato.catalogo.length + ' | carte ' + carte.length + '\n' +
        'foto: chieste ' + img.filter(function (i) { return i.getAttribute('src'); }).length +
        ' | arrivate ' + img.filter(function (i) { return i.complete && i.naturalWidth > 0; }).length +
        ' | fallite ' + document.querySelectorAll('.pd-card__ripiego').length + '\n' +
        'carta ' + (r ? Math.round(r.width) + 'x' + Math.round(r.height) : '—') +
        ' | scelte ' + stato.scelte.filter(Boolean).length + '/' + quante() + '\n' +
        'supporto: aspect-ratio ' + prova('aspect-ratio: 1 / 1') +
        ' | blend ' + prova('mix-blend-mode: multiply') +
        ' | IO ' + (('IntersectionObserver' in window) ? 'si' : 'NO') + '\n' +
        (errori.length ? 'ERRORI: ' + errori.slice(0, 3).join(' // ') : 'nessun errore js');
    }
    scrivi();
    setInterval(scrivi, 1000);
  }

  function avvia() {
    conti();
    diagnostica();
    clip();
    galleria();
    lineaDelTempo();
    nastri();
    [].forEach.call(document.querySelectorAll('[data-pd-cassetto]'), preparaCassetto);
    [].forEach.call(document.querySelectorAll('[data-pd-offerta]'), preparaOfferta);
    /* I pulsanti sparsi nella pagina portano all'offerta in alto. */
    [].forEach.call(document.querySelectorAll('[data-pd-vaisu]'), function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        var meta = document.querySelector('[data-pd-offerta]');
        if (meta) meta.scrollIntoView({behavior: 'smooth', block: 'center'});
      });
    });
    /* 10/10/2026 — coppie gia' pronte (landing di Halloween). Un pulsante
       con data-pd-coppia="handle-a,handle-b" mette quelle due borse nelle
       caselle. Se una delle due non e' nel catalogo della pagina non si
       tocca niente: il pulsante porta comunque all'offerta (data-pd-vaisu)
       e si sceglie a mano. */
    [].forEach.call(document.querySelectorAll('[data-pd-coppia]'), function (b) {
      if (b.dataset.pdCoppiaPronta === '1') return;
      b.dataset.pdCoppiaPronta = '1';
      b.addEventListener('click', function () {
        var nomi = (b.getAttribute('data-pd-coppia') || '').split(',').map(function (x) { return x.trim(); }).filter(Boolean);
        if (!nomi.length || quante() < nomi.length) return;
        var trovate = nomi.map(function (h) {
          return stato.catalogo.filter(function (c) { return c.handle === h; })[0] || null;
        });
        if (trovate.indexOf(null) !== -1) return;
        stato.scelte = trovate.slice(0, quante());
        while (stato.scelte.length < quante()) stato.scelte.push(null);
        disegnaTutto();
      });
    });
  }

  if (document.readyState !== 'loading') { avvia(); }
  else { document.addEventListener('DOMContentLoaded', avvia); }
  document.addEventListener('shopify:section:load', avvia);
})();
